export const environment = {
  env: 'DEV',
  production: false,
  googleAnalyticsDevMode: false,

  serverBaseUrl: 'https://fp-dev-server.freshprints.com/',
  serverUrl: 'https://fp-dev-server.freshprints.com/api/',
  authToken: 'Basic ZnBhZG1pbjpmcHNlY3JldA==',

  appUrl: "https://freshprints-web-dev.internal-fp.com/",
  adminV3Url: 'https://v3-dev.internal-fp.com/',
  adminV3DashboardUrl: 'https://v3-dev.internal-fp.com/dashboard/',
  customerPortalUrl: 'https://hq-dev.internal-fp.com/',
  designToolUrl: 'https://dt-dev.internal-fp.com',
  fpUrl: 'https://freshprints-dev.internal-fp.com',
  apiServerUrl: 'https://api-dev.internal-fp.com/',

  mixpanelToken: "9b1a582eab43292e2309acf265a5ec5c",

  algolia: {
    baseUrl: 'https://VJKL4FN2UO-dsn.algolia.net/1/indexes/shopify_testproducts',
    apiKey: '0990c2a8cb6a7de19c91d3acaa16f227',
    appId: 'VJKL4FN2UO',
    index: 'shopify_testproducts'
  },

  shopify: {
    url: 'https://freshprintstest.myshopify.com/api/graphql',
    shopifyAccessTtoken: '2bc5146b5965420c1ac6226b7c730baf'
  },

  iterableConfig: {
    apiKey: "e23135981e364e7c83170be1550e5164",
    eventUrl: "https://api.iterable.com/api/events/track",
    userUrl: "https://api.iterable.com/api/users/update"
  },

  cloudImageCdn: "https://alofmzptzp.cloudimg.io/v7/",

  httpCall: {
    authDetails: 'Basic ZnBhZG1pbjpmcHNlY3JldA=='
  },

  GOOGLE_PAY_MERCHANT_ID: 'BCR2DN4TUPT5FSSK',
};
